import {useMutation} from '@tanstack/react-query';
import conversationMessagesUpdaters from '@/api/updaters/conversationMessages';

export type UseMarkUnreadOptions<TSnapshot = unknown> = {
  onMutate?: (variables: {messageId: string}) => TSnapshot;
  onError?: (context: TSnapshot) => void;
};

function useMarkUnread<TSnapshot = unknown>({
  onMutate,
  onError,
}: UseMarkUnreadOptions<TSnapshot> = {}) {
  return useMutation<void, Error, {messageId: string}, TSnapshot>({
    mutationKey: ['conversations', 'markUnread'],
    mutationFn: ({messageId}) =>
      conversationMessagesUpdaters.markUnread(messageId),
    onMutate: onMutate ? (variables) => onMutate(variables) : undefined,
    onError: onError
      ? (_err, _vars, context) => {
          if (context !== undefined) {
            onError(context);
          }
        }
      : undefined,
  });
}

export default useMarkUnread;
